import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const AuthgorisedSignatories = ({ values }) => (
  <Content>
    {({
      businessMandateAuthorisedSignatoriesLabel,
      businessMandateAuthorisedSignatoriesValue1,
      businessMandateAuthorisedSignatoriesValue2,
      businessMandateAuthorisedSignatoriesValue3,
      globalRadioError,
      mandateVale1 = '1',
      mandateVale2 = '2',
      mandateVale3 = '3'
    }) => (
      <Field
        name="no_signatories_to_sign"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="no_signatories_to_sign"
            title={businessMandateAuthorisedSignatoriesLabel}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.StackedSet
              groupName="no_signatories_to_sign"
              items={[
                {
                  id: mandateVale1,
                  labelText: businessMandateAuthorisedSignatoriesValue1
                },
                {
                  id: mandateVale2,
                  labelText: businessMandateAuthorisedSignatoriesValue2
                },
                {
                  id: mandateVale3,
                  labelText: businessMandateAuthorisedSignatoriesValue3
                }
              ]}
              selectedId={values.no_signatories_to_sign}
              {...input}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default AuthgorisedSignatories;
